import { render, staticRenderFns } from "./MemberSummaryByTypeReport.vue?vue&type=template&id=31ff1190&scoped=true&"
import script from "./MemberSummaryByTypeReport.vue?vue&type=script&lang=js&"
export * from "./MemberSummaryByTypeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff1190",
  null
  
)

export default component.exports